import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitRegisterRequest, ApiPurpleFitUpdateUserInfoRequest, PRPVUserFull, UserRequest } from '../../../core-modules/sdk';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/default/environment';
import { PurpleTranslationPipe, PurpleTranslationService } from '@purple-lib/purple-translations-core';
import { PurpleFormComponent, PurpleFormFieldsGroup, PurpleSimpleButtonComponent, PurpleSimpleNotificationService, ShowPurpleSimpleNotificationRequest } from '@purple-lib/purple-ui-widgets';
import { PurpleApiMakeRequestResponse, PurpleBreakpointsService } from '@purple-lib/purple-utilities';
import { PurpleUserService, LoginType } from '@purple-lib/purple-users-core';
import { PurpleEditableImageDirective } from '@purple-lib/purple-edit-medias';
import { PurpleEditableTextDirective } from '@purple-lib/purple-edit-translations';
import { PurpleFitCoreTranslations } from '../../../core-modules/constants/purple-fit-core-translations';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['../authentication.scss', './reset-password.component.scss'],
  imports: [CommonModule, FormsModule, PurpleTranslationPipe, PurpleEditableTextDirective, PurpleFormComponent, PurpleSimpleButtonComponent, PurpleEditableImageDirective]
})
export class ResetPasswordComponent implements OnInit {
  protected readonly T = PurpleFitCoreTranslations;

  constructor(private fb: FormBuilder, public breakSvc: PurpleBreakpointsService,
    private userSvc: PurpleUserService<PRPVUserFull, ApiPurpleFitRegisterRequest, ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitUpdateUserInfoRequest>,
    public tsvc: PurpleTranslationService, private psNotSvc: PurpleSimpleNotificationService, private router: Router, private route: ActivatedRoute) {
    this.validateForm = this.fb.group({});
  }

  validateForm!: FormGroup;
  purpleFormFieldGroups: PurpleFormFieldsGroup[] | undefined;
  rememberCheck: boolean = true;
  otherLoginLineWidth: number = 10;
  otherLoginTextw: number = 0;

  resetId: string | undefined;
  isLoading: boolean = false;

  resetErrorReq!: ShowPurpleSimpleNotificationRequest;

  ngOnInit() {
    this.resetErrorReq = {
      autoClose: true,
      buttonText: this.tsvc.getTranslationValue(this.T.reset_password_check_reset_id_modal_button),
      title: this.tsvc.getTranslationValue(this.T.reset_password_check_reset_id_title_ko),
      message: this.tsvc.getTranslationValue(this.T.reset_password_check_reset_id_subtitle_ko),
      buttonFunction: async () => {
        await this.router.navigate([this.tsvc.currentLanguage(), 'request-reset-password']);
      },
      mobileSettings: {
        mobileType: 'modal',
        closable: false,
        maskClosable: false
      },
      desktopSettings: {
        closable: false,
        maskClosable: false
      }
    };


    this.route.queryParams.subscribe(async params => {
      const rf1 = params["resetField1"];
      //const rf2 = params["resetField2"];
      this.resetId = params["resetId"];

      if (this.resetId == undefined) {
        this.psNotSvc.showPurpleSimpleNotification(this.resetErrorReq);
      }

      await this.userSvc.checkResetPasswordLinkUrl(this.resetId!, undefined, false, environment.LOADER_ID, 0, ((res: PurpleApiMakeRequestResponse<UserRequest>, isMobile: boolean) => {
        this.resetErrorReq.message = res.message;

        this.psNotSvc.showPurpleSimpleNotification(this.resetErrorReq);
      }));

      this.purpleFormFieldGroups = [
        {
          fieldGroupNumber: 1,
          fieldGroupBootstrapColumn: 12,
          fieldGroupPaddingLeft: false,
          fieldGroupPaddingRight: false,
          formFieldFormGroup: this.validateForm,
          formFields: [
            {
              fieldType: 'input-text',
              fieldControlName: 'email',
              fieldBootstrapColumn: 12,
              fieldName: this.tsvc.getTranslationValue(this.T.reset_password_page_form_email, []),
              fieldPlaceholder: "",
              fieldValue: rf1,
              fieldIsRequired: true,
              fieldPaddingLeft: false,
              fieldPaddingRight: false,
              fieldIsDisabled: true,
              fieldCustomValidators: [Validators.email],
              fieldCustomValidatorErrors: [{ errorId: "email", text: this.tsvc.getTranslationValue(this.T.invalid_email_validator_error_text) }]
            },
            {
              fieldType: 'input-text',
              fieldControlName: 'password',
              fieldBootstrapColumn: 12,
              fieldName: this.tsvc.getTranslationValue(this.T.reset_password_page_form_password, []),
              fieldPlaceholder: "",
              fieldValue: undefined,
              fieldIsRequired: true,
              fieldPaddingLeft: false,
              fieldPaddingRight: false,
              fieldOptions: [{ id: 'isPassword', value: true }],
              fieldCustomValidators: [this.validatePassword],
              fieldCustomValidatorErrors: [{ errorId: "format", text: this.tsvc.getTranslationValue(this.T.invalid_email_validator_error_text) }]
            },
            {
              fieldType: 'input-text',
              fieldControlName: 'newPassword',
              fieldBootstrapColumn: 12,
              fieldName: this.tsvc.getTranslationValue(this.T.reset_password_page_form_new_password, []),
              fieldPlaceholder: "",
              fieldValue: undefined,
              fieldIsRequired: true,
              fieldPaddingLeft: false,
              fieldPaddingRight: false,
              fieldOptions: [{ id: 'isPassword', value: true }],
              fieldCustomValidators: [this.confirmationValidator],
              fieldCustomValidatorErrors: [{ errorId: "match", text: this.tsvc.getTranslationValue(this.T.invalid_email_match_validator_error_text) }]
            }
          ]
        }
      ]
    });
  }

  //return basic observable

  async resetPassword() {
    this.isLoading = true;
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }

    if (this.validateForm.valid) {
      await this.userSvc.resetPassword(LoginType.Email, this.validateForm.controls['password'].value, this.resetId!, "web", async (_: boolean) => {
        await this.router.navigate([this.tsvc.currentLanguage(), 'login']);
      }, false, environment.LOADER_ID, 0, (res: PurpleApiMakeRequestResponse<void>, _: boolean) => {
        this.resetErrorReq.message = res.message;

        this.psNotSvc.showPurpleSimpleNotification(this.resetErrorReq);
      });
    }
    this.isLoading = false;
  }


  validatePassword = (control: AbstractControl): ValidationErrors | null => {
    const re = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    const res = re.test(String(control.value));
    if (!res) {
      return { format: true }
    }
    return {}
  }

  confirmationValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.validateForm.controls['password'].value) {
      return { match: true };
    }
    return {};
  };

}
